import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const getShowTemplateSelect = (
    state: IApplicationState
): boolean => {
    const user = getAuthUser(state);
    return user && user.meta && user.meta.isShowTemplateSelect;
};
